export const getIntlLocale = (language?: string): string => {
  if (!language) {
    return 'en-US';
  }

  return language.startsWith('de') ? 'de-AT' : 'en-US';
};

export const formatDate = (value: string | number | Date, language?: string): string =>
  new Intl.DateTimeFormat(getIntlLocale(language), {
    dateStyle: 'medium',
  }).format(new Date(value));

export const formatDateTime = (value: string | number | Date, language?: string): string =>
  new Intl.DateTimeFormat(getIntlLocale(language), {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(new Date(value));

export const formatCurrency = (value: number, language?: string, currency = 'EUR'): string =>
  new Intl.NumberFormat(getIntlLocale(language), {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
